<template>
  <CheckoutStep class="h-full">
    <template #header>
      <Stepper />
    </template>
    <template #aside>
      <GiftCardSummary
        v-if="giftCard"
        :asset-url="giftCard.designAsset.assetUrl"
        :price="giftCard.price"
      />
    </template>

    <div aria-live="polite" role="status">
      <BillingAddress :billing-address @update="handleUpdate" />
    </div>
  </CheckoutStep>
</template>

<script setup lang="ts">
import { navigateTo, useRoute } from '#imports'

import type { Bill } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import CheckoutStep from '@backmarket/nuxt-layer-checkout/components/CheckoutStep/CheckoutStep.vue'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

import GiftCardSummary from '../../components/GiftCardSummary/GiftCardSummary.vue'
import Stepper from '../../components/Stepper/Stepper.vue'

import BillingAddress from './components/BillingAddress/BillingAddress.vue'

const route = useRoute()

defineProps<{
  giftCard: ApiSpecs['/api/gift-cards/v1/product-page/giftcard/request/:requestId']['GET']['response']
  billingAddress: Bill
}>()

const emit = defineEmits<{
  (e: 'update', callback: () => void): void
}>()

function handleUpdate() {
  emit('update', () => {
    if (route.name === CHECKOUT.GIFT_CARDS.WEBVIEW.BILLING_ADDRESS) {
      navigateTo({ name: CHECKOUT.GIFT_CARDS.WEBVIEW.PAYMENT })
    } else {
      navigateTo({ name: CHECKOUT.GIFT_CARDS.PAYMENT })
    }
  })
}
</script>
